import { Button } from '@daily/shared/components/Button';
import { Modal } from '@daily/shared/components/Modal';
import { Stack } from '@daily/shared/components/Stack';
import { Text } from '@daily/shared/components/Text';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { isIOSMobile, isSafari } from '../../lib/browserConfig';
import { UnblockPermissionsInstructions } from './UnblockPermissionsInstructions';
import { useSafariUnblockPermissions } from './useSafariUnblockPermissions';

export const UnblockPermissionsModal: React.FC<
  React.PropsWithChildren<React.ComponentProps<typeof Modal>>
> = ({ closeText, onClose }) => {
  const { t } = useTranslation();

  const { grantAccess } = useSafariUnblockPermissions();
  const handleGrantAccessClick = useCallback(
    async (close) => {
      grantAccess({
        onSuccess: close,
      });
    },
    [grantAccess]
  );

  const actions = useMemo(() => {
    if (isSafari() || isIOSMobile()) {
      return [
        <Button
          id="unblock-permissions-modal-grant"
          key="grant"
          variant="primary"
          onClick={handleGrantAccessClick}
        >
          {t('haircheck.blocked.grantAccess')}
        </Button>,
        <Button
          id="unblock-permissions-modal-close"
          key="close"
          variant="secondary"
        >
          {closeText}
        </Button>,
      ];
    }

    return [
      <Button
        id="unblock-permissions-modal-dismiss"
        key="dismiss"
        variant="primary"
      >
        {t('general.dismiss')}
      </Button>,
    ];
  }, [closeText, handleGrantAccessClick, t]);

  return (
    <Modal
      actions={actions}
      onClose={onClose}
      title={t('haircheck.blocked.unblockModalTitle')}
    >
      <Stack>
        <Text variant="large" El="p">
          {t('haircheck.blocked.unblockModalContentText')}
        </Text>
        <UnblockPermissionsInstructions hideUnblockButton />
      </Stack>
    </Modal>
  );
};
